"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConcreteMathEvaluator = void 0;
class ConcreteMathEvaluator {
    async evaluate(submission, activity) {
        const config = activity.config;
        const targetCount = config?.targetCount ?? 0;
        const structured = submission.structuredData;
        const placedCount = typeof structured?.placedCount === 'number'
            ? structured.placedCount
            : (typeof structured?.answer === 'number' ? structured.answer : parseInt(String(structured?.answer || '0'), 10));
        const isCorrect = placedCount === targetCount;
        const score = isCorrect ? 100 : (targetCount > 0 ? Math.max(0, Math.round((placedCount / targetCount) * 100)) : 0);
        const itemType = config?.itemType || 'items';
        let feedback = '';
        if (isCorrect) {
            feedback = `Super! You put exactly ${targetCount} ${itemType} in the ${config?.targetLabel || 'target'}!`;
        }
        else if (placedCount < targetCount) {
            const diff = targetCount - placedCount;
            feedback = `Almost there! You need ${diff} more ${itemType}.`;
        }
        else {
            const diff = placedCount - targetCount;
            feedback = `You have ${diff} too many ${itemType}. Take ${diff} back!`;
        }
        return {
            score: isCorrect ? 100 : Math.min(score, 70),
            maxScore: 100,
            isCorrect,
            feedback,
            breakdown: [
                {
                    name: 'Count Accuracy',
                    score: isCorrect ? 100 : 0,
                    maxScore: 100,
                    feedback: isCorrect ? 'Target quantity matched' : `Expected ${targetCount}, placed ${placedCount}`,
                },
            ],
            skills: [
                { key: `maths:concrete_counting:${targetCount}`, label: `Counting to ${targetCount}` },
            ],
            label: 'Counting Score',
        };
    }
}
exports.ConcreteMathEvaluator = ConcreteMathEvaluator;
